import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { usePdfDownloader } from "../common/usePdfDownloader";
import "../Menu.css";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI } from "../utils/fetchData";
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const RegulatoryCompliances = () => {
	const [complience, SetComplience] = useState([]);
	const dispatch = useDispatch();
	const downloadPdf = usePdfDownloader();

	useEffect(() => {
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });

		getDataAPI(`getregulatories`).then((res) => {
			console.log("res getregulatories", res.data);
			SetComplience(res.data.regulatories);
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { loading: false },
			});
		});
	}, []);

	return (
		<>
			<Navbar />
			<Homecarousel />
			<div className="rc">
				<div className="rc-heading">
					<h2>🌐 Regulatory Compliance Guidance</h2>
				</div>
				<div className="row">
					<div className="col-xl-8 col-lg-8 col-md-12 col-sm-12">
						<div className="rc-box">
							<div className="rc-box1">
								{/* <h6 style={{ marginBottom: "15px" }}>
							Regulatory Compliance for Global Food Safety and Sustainability
							Standards
						</h6> */}
								<p>
									Ensuring compliance across the food chain is critical to
									implementing global standards and enabling smooth, risk-free
									trade. The Global Academy portal offers easy access to key
									regulatory guidance—covering both domestic and international
									requirements—to support your journey toward certification and
									market readiness.
								</p>

								<i>
									⚠️ Disclaimer: While we provide regulatory information to the
									best of our knowledge, users are strongly advised to conduct
									their own due diligence for full legal compliance.
								</i>

								<h6 style={{ marginTop: "20px", marginBottom: "20px" }}>
									✅ Key Benefits for Food Chain Stakeholders
								</h6>

								<ul style={{ margin: "0px", padding: "0px" }}>
									<li>
										<div className="rc-list">
											<div className="rc-icon">
												<svg
													aria-hidden="true"
													className="e-font-icon-svg e-fas-leaf"
													viewBox="0 0 576 512"
													xmlns="http://www.w3.org/2000/svg">
													<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
												</svg>
											</div>
											<span className="rc-text">
												<b> 📚 Risk Reduction</b>
												<br />
												Avoid non-compliance, legal penalties, and certification
												delays through clear regulatory insights.
											</span>
										</div>
									</li>
									<li style={{ margin: "0px" }}>
										<div className="rc-list">
											<div className="rc-icon">
												<svg
													aria-hidden="true"
													className="e-font-icon-svg e-fas-leaf"
													viewBox="0 0 576 512"
													xmlns="http://www.w3.org/2000/svg">
													<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
												</svg>
											</div>
											<span className="rc-text">
												<b> 🌍 Market Access</b>
												<br />
												Understand export/import rules and certifications to
												confidently enter new markets.
											</span>
										</div>
									</li>
									{/* <li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										<b>Cost and Time Savings:</b> Consolidated and up-to-date
										information helps users save resources and make informed
										decisions.
									</span>
								</div>
							</li>
							<li style={{ margin: "0px" }}>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										<b>Improved Market Access: </b> Understanding export and
										import requirements boosts opportunities to enter new
										markets.
									</span>
								</div>
							</li> */}
								</ul>
								{/* <p style={{ marginBottom: "10px" }}>
							We empower users to confidently navigate the complex regulatory
							landscape.
						</p> */}
							</div>
						</div>
					</div>
					<div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 pt-rc">
						<div className="rc-box2">
							<h6>Guidance </h6>
							<ul style={{ margin: "0px", padding: "0px" }}>
								{complience.map((val, index) => {
									return (
										<li
											onClick={() => {
												downloadPdf(val.source);
											}}>
											<div className="rc-list">
												<div className="rc-icon">
													<svg
														aria-hidden="true"
														className="e-font-icon-svg e-fas-leaf"
														viewBox="0 0 576 512"
														xmlns="http://www.w3.org/2000/svg">
														<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
													</svg>
												</div>
												<span
													style={{ textDecoration: "underline" }}
													className="rc-text">
													{val.name}
												</span>
											</div>
										</li>
									);
								})}

								{/* <li>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										Permitted Plant Protection Products for Use
									</span>
								</div>
							</li>
							<li>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										Importance of Regulatory Compliance for Food Imports
									</span>
								</div>
							</li>
							<li>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										Regulatory Compliances for food export from India
									</span>
								</div>
							</li>
							<li>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										Regulatory Compliances for food import from India
									</span>
								</div>
							</li>
							<li>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										Regulatory Compliances for food importation into India
									</span>
								</div>
							</li>
							<li>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										Regulatory Compliances for Organic food export from India
									</span>
								</div>
							</li>
							<li>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										Establishing Food Business in India
									</span>
								</div>
							</li>
							<li>
								<div className="rc-list">
									<div className="rc-icon">
										<svg
											aria-hidden="true"
											className="e-font-icon-svg e-fas-leaf"
											viewBox="0 0 576 512"
											xmlns="http://www.w3.org/2000/svg">
											<path d="M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"></path>
										</svg>
									</div>
									<span className="rc-text">
										Testing in Accredited Labs under International Standard ISO
										17025
									</span>
								</div>
							</li> */}
							</ul>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default RegulatoryCompliances;
